import type { Auth } from "@corpuscomplete/core/auth";
import { createAuthClient } from "better-auth/react";
import { inferAdditionalFields } from "better-auth/client/plugins";
import { queryClient } from "../query-client";
import { Env } from "../env";

/** Better Auth browser client; uses credentialed cookies against the API base URL. */
export const authClient = createAuthClient({
  baseURL: Env.VITE_API_URL,
  fetchOptions: {
    credentials: "include",
  },
  plugins: [inferAdditionalFields<Auth.Value>()],
});

export type SessionData = typeof authClient.$Infer.Session;

/** Shared session query contract for route guards/loaders (`SessionData | null`, never redirect). */
export const sessionQueryOptions = {
  queryKey: ["session"] as const,
  queryFn: async () => {
    const result = await authClient.getSession();
    return result.data;
  },
  staleTime: 60 * 1000, // 1 minute - matches server cookie cache
};

/** Loader-safe session read that dedupes in-flight calls through TanStack Query cache. */
export async function getCachedSession(): Promise<{ data: SessionData | null }> {
  const data = await queryClient.ensureQueryData(sessionQueryOptions);
  return { data };
}
